(function (angular) {
  "use strict";

  angular.module("app").factory("extendResource", extendResource);

  extendResource.$inject = ["$rootScope"];

  function extendResource($rootScope) {
    /**
     * Stops error alerts being shown for requests (ie. controller will handle all errors)
     * @return {this}
     */
    function suppressValidationAlerts() {
      var requestString = JSON.stringify(this);

      $rootScope.suppressedRequests.push(requestString);

      return this;
    }

    /**
     * Adds extra prototype methods onto resources
     * @param  {$resource} resource - angular resource
     * @return {$resource}
     */
    return function resourceExtender(resource) {
      resource.prototype.suppressValidationAlerts = suppressValidationAlerts;
      return resource;
    };
  }
})(angular);
